import { render, staticRenderFns } from "./DynamicMappings.vue?vue&type=template&id=73c7416f&"
import script from "./DynamicMappings.vue?vue&type=script&lang=ts&"
export * from "./DynamicMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports